import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FormElement',
  props: {
    tagName: { type: String, required: true },
    value: { type: String, required: true },
    title: { type: String, required: false },
    errorText: { type: String, required: false },
    isValid: { type: Boolean, required: false },
    specialPlaceholder: { type: String, required: false },
  },
  emits: ['update:value'],
  setup(_, { emit }) {
    const onInput = (event: Event & { target: HTMLInputElement }) => {
      const { value } = event.target as HTMLInputElement
      emit('update:value', value)
    }
    return { onInput }
  },
})
